import type { ProjectTemplate } from '../types';

/**
 * Sums tasks/statuses across every board in the template. The backend's summary DTO doesn't
 * carry these counts (see `tasks/project-templates-backend-contract.md` §7) — the gallery
 * card needs the full detail fetched to derive them.
 */
export function countTemplateTasks(template: ProjectTemplate): number {
  return template.boards.reduce((sum, board) => {
    const groupTasks = board.groups.reduce((groupSum, group) => groupSum + group.tasks.length, 0);
    return sum + groupTasks + board.ungroupedTasks.length;
  }, 0);
}

export function countTemplateStatuses(template: ProjectTemplate): number {
  return template.boards.reduce((sum, board) => sum + board.statuses.length, 0);
}
